import { useState, useCallback } from 'react';
import { SPINNER_DIALOGS } from '~/app/constants';

/**
 * usePaymentCapture
 *
 * Owns the in-office payment capture state that was previously class state
 * on FormViewer:
 *
 *   toggleReturnPayment(val)      — open/close the payment modal; queries calc engine on open
 *   setPaymentTerminalStatus(s)   — update terminal status
 *
 * State returned for render:
 *   returnPaymentOpen    — boolean
 *   paymentTerminalStatus — string | null
 *   returnPaymentInfo    — object
 *
 * Callers must supply:
 *   calcAPIRef  — ref to CalcAPI instance
 *   spinnerRef  — ref to spinner hook (for startSpin)
 *   SPINNER_DIALOGS — constant bag (passed from FormViewer constants)
 */
const usePaymentCapture = ({ calcAPIRef, spinnerRef }) => {
  const [returnPaymentOpen, setReturnPaymentOpen] = useState(false);
  const [paymentTerminalStatus, setPaymentTerminalStatus] = useState(null);
  const [returnPaymentInfo, setReturnPaymentInfo] = useState({});

  const toggleReturnPayment = useCallback(
    val => {
      if (val) {
        spinnerRef.current?.startSpin(SPINNER_DIALOGS.PROCESS_REQUEST);
        calcAPIRef.current?.ReturnPaymentQuery();
      }
      setReturnPaymentOpen(val);
      setPaymentTerminalStatus(null);
    },
    [calcAPIRef, spinnerRef],
  );

  return {
    returnPaymentOpen,
    paymentTerminalStatus,
    setPaymentTerminalStatus,
    returnPaymentInfo,
    setReturnPaymentInfo,
    toggleReturnPayment,
  };
};

export default usePaymentCapture;
